<template>
  <div>
    <div class="XVgraphcontrol" v-for="(graphitem, index) in graphdata" :key="index">
      <div
        class="row margin10"
        :class="{
          DisabledItem: graphitem.reportStatus && graphitem.reportStatus.tblRequestReportState === 1,
        }"
      >
        <div class="col-md-12">
          <span v-if="graphitem.graphIcon !== null">
            <font-awesome-icon :icon="getIcon(graphitem.graphIcon)" class="fa-2x graphicon" />
          </span>
          <span v-if="graphitem.graphIcon === null">
            <font-awesome-layers class="fa-2x fastackmargin">
              <font-awesome-icon :icon="['fal', 'file']" class="graphicon" />
              <font-awesome-icon icon="bars" class="graphicon" transform="shrink-11 up-4 left-2" />
              <font-awesome-icon icon="chart-area" class="graphicon" transform="shrink-8 down-3 left-0" />
            </font-awesome-layers>
          </span>
          &nbsp;
          <span @click="graphClick(graphitem)" class="fakelink graphUrl">{{ graphitem.graphName }}</span>
          <XVhelpcontrol v-if="graphitem.graphHelpTekst !== null" :helptext="graphitem.graphHelpTekst"></XVhelpcontrol>
        </div>
      </div>
      <fieldset v-if="graphitem.reportStatus && graphitem.reportStatus.tblRequestReportState !== 0" class="margin10">
        <div class="col-md-12 margin10">
          <span v-if="graphitem.reportStatus.tblRequestReportState < 2">
            <p><font-awesome-icon :icon="['fa', 'circle-notch']" class="fa-1x fa-spin" /> {{ translation(14638) }}</p>
          </span>
          <span v-if="graphitem.reportStatus.tblRequestReportState === 2">
            <p><font-awesome-icon :icon="['far', 'check']" class="fa-1x" />{{ translation(14639) }}</p>
            <p>
              <a :href="getDownloadUrl(graphitem.reportStatus.docid, graphitem.reportStatus.filehash)" target="_blank">
                {{ graphitem.reportStatus.tblPeDocumentenOriginalFilename }}
              </a>
            </p>
          </span>
          <span v-if="graphitem.reportStatus.tblRequestReportState === 3">
            <p><font-awesome-icon :icon="['fa', 'exclamation-triangle']" class="fa-1x" /> {{ translation(3137) }}</p>
          </span>
          <span v-if="graphitem.reportStatus.tblRequestReportState === 4">
            <p><font-awesome-icon :icon="['fa', 'exclamation-triangle']" class="fa-1x" />{{ translation(31387) }}</p>
          </span>
        </div>
        <div class="margin10"></div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { FAMixin } from 'pevueglobal'
import { mapMutations } from 'vuex'
export default {
  mixins: [FAMixin],
  name: 'XVgraphcontrol',
  props: {
    graphdata: {
      type: Array,
      required: true,
    },
    filters: {},
  },
  data: function () {
    return {}
  },
  methods: {
    ...mapMutations(['addNotification']),
    getIcon(icon) {
      return JSON.parse(icon)
    },
    graphClick: function (graphitem) {
      if (graphitem.reasonNotClickable === null) {
        let graphID = graphitem.graphID
        let graphShowInPopup = graphitem.graphShowInPopup
        this.$emit('graphClick', { graphID, graphShowInPopup })
      } else {
        this.addNotification({
          groupname: 'warning',
          message: graphitem.reasonNotClickable,
          sticky: true,
        })
      }
    },
  },
}
</script>

